import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from './Button';
import useBookPoonam from '../../utils/useBookPoonam';

// On a phone the main action is always one thumb-tap away: a slim "Book Your Session" bar slides up from the bottom of the
// information pages once the visitor has scrolled past the top, and steps aside when the footer is on screen. Desktop has the
// "Book Now" button in the header instead, so this is for small screens only.
const SHOWN_ON = ['/', '/media-profile', '/services', '/seminar', '/blog', '/astrologers', '/contactUs'];

const StickyBookBar = () => {
  const { pathname } = useLocation();
  const { bookSession, bookLabel, isBooking } = useBookPoonam();
  const [scrolled, setScrolled] = useState(false);
  const [footerInView, setFooterInView] = useState(false);

  const enabled = SHOWN_ON.some((path) => (path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`)));

  useEffect(() => {
    if (!enabled) return undefined;
    const onScroll = () => setScrolled(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [enabled, pathname]);

  useEffect(() => {
    if (!enabled || typeof IntersectionObserver === 'undefined') return undefined;
    const footer = document.querySelector('footer');
    if (!footer) return undefined;
    const observer = new IntersectionObserver(([entry]) => setFooterInView(entry.isIntersecting), { threshold: 0.05 });
    observer.observe(footer);
    return () => observer.disconnect();
  }, [enabled, pathname]);

  if (!enabled) return null;
  const visible = scrolled && !footerInView;

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-brand-border/70 bg-canvas/95 px-4 pt-3 shadow-[0_-14px_24px_-18px_rgba(16,53,46,0.45)] backdrop-blur-md transition-transform duration-500 ease-premium md:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`}
      style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom, 0px))' }}
      aria-hidden={!visible}
    >
      <Button variant="primary-dark" className="w-full !py-4" onClick={bookSession} loading={isBooking} tabIndex={visible ? 0 : -1}>
        {bookLabel}
      </Button>
    </div>
  );
};

export default StickyBookBar;
